import React, { useContext } from "react";
import PWall_Main from "./PWall_Main";
import PWall_Success from "./PWall_Success";
import UserContext from "../../pages/Login/UserContext";
import PWall_CreateAccount from "./PWall_CreateAccount";
import PWall_Processing from "./PWall_Processing";

// Controls which content to show inside the Paywall popup
// flowState: 'main' | 'success' | 'createAccount'
export default function PWallStateManager({ flowState, setFlowState, onExit, setSubscriptionID }) {
  const { user } = useContext(UserContext);

  const handleSuccessContinue = () => {
    if (user?.isGuest) {
      setFlowState && setFlowState('createAccount');
    } else {
      onExit && onExit();
    }
  };

  switch (flowState) {
    case 'processing':
      return <PWall_Processing onExit={onExit} />;
    case 'success':
      return <PWall_Success onExit={onExit} onContinue={handleSuccessContinue} />;
    case 'createAccount':
      return <PWall_CreateAccount onCompleted={onExit} />;
    case 'main':
    default:
      return <PWall_Main onExit={onExit} setSubscriptionID={setSubscriptionID} />;
  }
}


